import { cn } from '@/lib/utils'
import { RadioGroup as RadioGroupRadix } from 'radix-ui'

const RadioGroupRoot = ({
  className,
  children,
  ...props
}: React.ComponentProps<typeof RadioGroupRadix.Root>) => (
  <RadioGroupRadix.Root
    className={cn('flex flex-col gap-2.5', className)}
    {...props}
  >
    {children}
  </RadioGroupRadix.Root>
)

RadioGroupRoot.displayName = 'RadioGroupRoot'

export default RadioGroupRoot
